import Vue from 'vue'
import Router from 'vue-router'
// 当路由增多时，router中每个component都需要实现懒加载，但是在开发环境中使用懒加载，会导致代码更改的热更新速度变慢，需要区分环境来使用路由的懒加载功能，所以有了_import_development.js/_import_production.js来区分
const _import = require('./_import_' + process.env.NODE_ENV) // 引入_import_development/_import_production

Vue.use(Router)

// 解决重复路由跳转的问题
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 公共路由
export const constantRouterMap = [
  // 登录
  {
    path: '/login',
    name: '登录',
    component: _import('login/login'),
    hidden: true
  },
  // 404
  {
    path: '/404',
    name: '404',
    component: _import('login/404'),
    hidden: true
  }
]

// 权限路由
export const asyncRouterMap = [
]

export default new Router({
  scrollBehavior: () => ({ y: 0 }), // 切换路由时，让页面滚到顶端
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js